import { useMemo } from "react";

import { useClientsQuotas } from "~/modules/client/api/quota/quotaQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { mapDataToInputOptionsData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


const useClientsQuotaSelectOptions = (clientId: string): FormInputOption[] => {
	const { data: allQuotasData } = useClientsQuotas(clientId);
	return useMemo(() => {
		if (allQuotasData) {

			return mapDataToInputOptionsData(allQuotasData.sort(byObjectProperty("title")), "id", "title");
		}
		return [];
	}, [allQuotasData]);
};

export default useClientsQuotaSelectOptions;

